export interface ImageSize {
  width: number;
  height: number;
}

export async function toImageSize(base64OrUrl: string): Promise<ImageSize> {
  if (!base64OrUrl) {
    return { width: 0, height: 0 };
  }

  const img = new Image();

  await new Promise((resolve) => {
    img.src = base64OrUrl;
    img.onload = () => resolve(null);
    img.onerror = (error) => {
      console.error('Error loading image:', error);
      resolve(null);
    };
  });

  return {
    width: img.width || 0,
    height: img.height || 0
  };
}
